// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toOpM6lrJ7TIqxyAIDOH {
  height: 1.25rem;
  width: 1.25rem;
  fill: var(--gray-500);
}
`, "",{"version":3,"sources":["webpack://./src/lib/components/icon/icon.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB","sourcesContent":[".icon {\n  height: 1.25rem;\n  width: 1.25rem;\n  fill: var(--gray-500);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `toOpM6lrJ7TIqxyAIDOH`
};
export default ___CSS_LOADER_EXPORT___;
